<template>
  <Breadcrumbs
      title="Distributor Banks"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Distributor Banks', path: '/distributor-banks' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <distributorBanks/>
    </div>
  </div>
</template>

<script>
import distributorBanks from './distributor_banks_form.vue'
export default {
  name: 'indexList',
  components: {
    distributorBanks,
  },
}
</script>